export default {
  path: '/databases',
  name: 'databases',
  meta: {
    layout: 'main',
    breadcrumb: {
      linkTo: 'databases',
      linkText: 'Базы'
    }
  },
  component: () => import('../views/databases/Databases.vue')
}